export default __webpack_public_path__ + "static/media/signup-img.07edd0e0.jpg";